const LOCALE_DATA: Record<string, Record<string, string>> = {
  'ko-KR': {
    CHAT_GET_ITEM: '모아봐~!',
    SELECT_ITEM: '골라봐~!',
    NINIMO_INVENTORY: '니니모의 전리품',
    ITEM_DESCRIPTION_1: '제일 찾기 쉬운 아이템이다 니니!',
    ITEM_DESCRIPTION_2: '어디서 나타날지 모르는 특별 선물!',
    ITEM_DESCRIPTION_3: '유령은 발이 없는데 어떻게 점프를 할까?',
    ITEM_DESCRIPTION_4: '오이가 제일 싫다 니니!',
    ITEM_DESCRIPTION_5: '인스타그램 놀러와봤니니?',
    ITEM_DESCRIPTION_6: '야채 밭을 달리다 보면!',
    GET_ITEM: '전리품 획득!',
    GET_ITEM_DESCRIPTION_1: '어디에 쓰는걸까...?',
    GET_ITEM_DESCRIPTION_2: '짜잔!',
    GET_ITEM_DESCRIPTION_3: '이건 뭐니니?',
    TOP_10_RANK_BOARD: '주간 Top 10 랭킹 보드',
    NICKNAME_POPUP_TITLE: '닉네임을 알려줘 니니!',
    CODE_POPUP_TITLE: '친구의 코드를 알려줘 니니!',
    CONFIRM: '확인',
    CANCEL: '취소',
    DRAWING_TUTORIAL: '야채 위에 있는\n패턴을 따라 그려 물리치세요!',
    RUNNING_TUTORIAL_1: '화면을 탭 해서\n방향을 전환해주세요!',
    RUNNING_TUTORIAL_2: '화면을 연속해서 탭하면\n속도가 빨라져요!',
    JUMPING_TUTORIAL: '화면을 탭 해서\n떨어지지 않도록 점프하세요!',
    FINAL_TUTORIAL_1: '좌, 우로 스와이프해서\n공격하세요!',
    FINAL_TUTORIAL_2: '위, 아래로 스와이프해서\n오이의 공격을 피하세요!',
    FINAL_TUTORIAL_3: '아래, 위로 스와이프해서\n오이의 공격을 피하세요!',
    EQUIP_DONE: '장착완료!',
    CONTINUE: '광고보고 이어하기!',
    GO_TO_HOME: '처음부터 다시하기',
    SHARE: '점수 자랑하기',
    COPY_LINK: '링크를 복사했다 니니!',
    TRY_TOO: '나도 해볼래!',
    RE_PLAY_WITH_NEW_RECORD: '신기록 세우러가기',
    NOTIFICATION_1: '원활한 플레이를 위해 크롬/사파리로 들어가길 추천한다 니니!',
    HOST: '방 만들기 (1:1)',
    JOIN: '참가하기',
    DRAWING_GAME: '그리기 게임',
    JUMPING_GAME: '점프 게임',
    START: '시작',
    READY: '준비',
    NOTIFICATION_SAFARI:
      '(Chrome 사용을 권장합니다)\n\nIOS - 설정 - Safari - IP주소 가리기 Off\n여야 멀티를 할 수 있습니다!',
    EMOTION: '이모티콘 보내기',
    TRY_AGIN: '다시하기',
    GO_HOME: '메인으로',
    INVITATION_CODE: '초대코드',
  },
  'en-US': {
    CHAT_GET_ITEM: "Let's collect",
    SELECT_ITEM: 'Choose one!',
    NINIMO_INVENTORY: "Ninimo's special items",
    ITEM_DESCRIPTION_1: 'This is the easiest item you can find!',
    ITEM_DESCRIPTION_2: 'Go on an adventure. A special gift will show up!',
    ITEM_DESCRIPTION_3: 'How can ghosts jump with no feet?',
    ITEM_DESCRIPTION_4: 'Ninimo hates cucumbers the most!',
    ITEM_DESCRIPTION_5: "Have you checked Ninimo's instagram?",
    ITEM_DESCRIPTION_6: 'You will find it when running around the farm!',
    GET_ITEM: 'Your item is collected!',
    GET_ITEM_DESCRIPTION_1: 'What is this item for?',
    GET_ITEM_DESCRIPTION_2: 'Ta-da!',
    GET_ITEM_DESCRIPTION_3: 'What is this?',
    TOP_10_RANK_BOARD: 'Weekly TOP 10 Players',
    NICKNAME_POPUP_TITLE: "What's your nickname?",
    CODE_POPUP_TITLE: 'Enter your invitation code!',
    CONFIRM: 'OK',
    CANCEL: 'CANCEL',
    DRAWING_TUTORIAL: 'Draw the patterns\nshowing on the vegetables',
    RUNNING_TUTORIAL_1: 'Tap to move & navigate\nyour direction',
    RUNNING_TUTORIAL_2: 'Keep tapping\nto run faster!',
    JUMPING_TUTORIAL: 'Tap the screen to jump\nTry not to fall!',
    FINAL_TUTORIAL_1: 'Swipe right and left\nto attack the enemy',
    FINAL_TUTORIAL_2: 'Swipe up and down to avoid\na damage from Cucumber ',
    FINAL_TUTORIAL_3: 'Swipe up and down to avoid\na damage from Cucumber ',
    EQUIP_DONE: 'Activate!',
    CONTINUE: 'Watch ad & Continue',
    GO_TO_HOME: 'Restart from Stage1',
    SHARE: 'Share',
    COPY_LINK: 'Copy link done!',
    TRY_TOO: 'I would like to try',
    RE_PLAY_WITH_NEW_RECORD: 'Set a new record!',
    NOTIFICATION_1: 'Chrome or Safari is recommended to play the game!',
    HOST: 'Create a room (1:1)',
    JOIN: 'Join a room',
    DRAWING_GAME: 'Drawing Game',
    JUMPING_GAME: 'Jumping Game',
    START: 'START',
    READY: 'READY',
    NOTIFICATION_SAFARI:
      '(recommend using Chrome)\n\nIOS - Settings - Safari - Hide IP Address  Off\nthen can be play multi!',
    EMOTION: 'Send Emoji',
    TRY_AGIN: 'Compete again!',
    GO_HOME: 'Go to main',
    INVITATION_CODE: 'Invitation Code',
  },
};

export default LOCALE_DATA;
